export class EntityAnonymizer {
    constructor(context, config = {
        persons: true,
        locations: true,
        organizations: true,
        misc: true
    }) {
        this.context = context;
        this.config = config;
    }
    setConfig(config) {
        this.config = config;
    }
    isTypeEnabled(type) {
        switch (type) {
            case 'PER':
                return this.config.persons;
            case 'LOC':
                return this.config.locations;
            case 'ORG':
                return this.config.organizations;
            case 'MISC':
                return this.config.misc;
            default:
                return true;
        }
    }
    mapNerTypeToEntityType(type) {
        switch (type) {
            case 'PER':
                return 'PERSON';
            case 'LOC':
                return 'LOCATION';
            case 'ORG':
                return 'ORGANIZATION';
            default:
                return type;
        }
    }
    reconstructEntities(tokens) {
        const entities = [];
        let currentText = "";
        let currentLabel = "";
        for (const token of tokens) {
            const entity = token.entity_group || token.entity || 'O';
            const word = token.word;
            const parts = entity.split('-');
            const prefix = parts[0];
            const type = parts.length > 1 ? parts[1] : parts[0];
            if (prefix === 'B') {
                if (currentText) {
                    if (this.isTypeEnabled(currentLabel)) {
                        const tag = this.context.getOrCreateTag(this.mapNerTypeToEntityType(currentLabel), currentText);
                        entities.push({ originalText: currentText, tag, type: currentLabel });
                    }
                }
                currentText = word;
                currentLabel = type;
            }
            else if (prefix === 'I' && type === currentLabel) {
                if (word.startsWith('##')) {
                    currentText += word.substring(2);
                }
                else {
                    currentText += ' ' + word;
                }
            }
            else {
                // Non-entity token (O) or mismatched I- tag - flush current entity if any
                if (currentText) {
                    if (this.isTypeEnabled(currentLabel)) {
                        const tag = this.context.getOrCreateTag(this.mapNerTypeToEntityType(currentLabel), currentText);
                        entities.push({ originalText: currentText, tag, type: currentLabel });
                    }
                    currentText = "";
                    currentLabel = "";
                }
            }
        }
        if (currentText && this.isTypeEnabled(currentLabel)) {
            const tag = this.context.getOrCreateTag(this.mapNerTypeToEntityType(currentLabel), currentText);
            entities.push({ originalText: currentText, tag, type: currentLabel });
        }
        return entities;
    }
    anonymize(text, entities) {
        let newText = text;
        const sortedEntities = [...entities].sort((a, b) => b.originalText.length - a.originalText.length);
        const processedStrings = new Set();
        for (const entity of sortedEntities) {
            if (processedStrings.has(entity.originalText))
                continue;
            const escaped = entity.originalText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(escaped, 'g');
            newText = newText.replace(regex, entity.tag);
            processedStrings.add(entity.originalText);
        }
        return newText;
    }
    getContext() {
        return this.context;
    }
}
